(function () {
  /* ciw-la-prescription-lenses-guard
   *
   * Root cause this guards against:
   * In the Progressive (No Line) flow, choosing a submission method that skips
   * manual entry (e.g. "Email Later") calls LensAdvizor.getPrescriptionLenses().
   * That widget method fetches the lenses, then preloads their images. For this
   * flow one of the image entries is null, so reading `.src` throws AFTER
   * `this.lenses` is already populated but BEFORE the method returns. The awaited
   * call rejects, the step transition aborts, and the modal spins forever on
   * "Choose how to add your prescription".
   *
   * Fix: wrap getPrescriptionLenses so a throw during the (cosmetic) image
   * preload no longer rejects the transition. The already-fetched lenses are
   * returned so the flow advances to the Lens Type step. Presentment prices are
   * recomputed on a best-effort basis so pricing stays correct.
   */
  var POLL_MS = 250;
  var MAX_WAIT_MS = 30000;

  function patch() {
    var la = window.LensAdvizor;
    if (!la || typeof la.getPrescriptionLenses !== 'function') {
      return false;
    }
    if (la.__ciwGplGuardPatched) {
      return true;
    }
    la.__ciwGplGuardPatched = true;

    var original = la.getPrescriptionLenses;
    la.getPrescriptionLenses = function () {
      var self = this;
      var args = arguments;

      return Promise.resolve()
        .then(function () {
          return original.apply(self, args);
        })
        .catch(function (err) {
          try {
            console.warn(
              '[ciw-la] getPrescriptionLenses recovered from error:',
              err && err.message
            );
          } catch (e) {}

          var lenses = self.lenses || [];

          if (typeof self.getPresentmentPrices === 'function') {
            return Promise.resolve()
              .then(function () {
                return self.getPresentmentPrices(lenses);
              })
              .then(function (prices) {
                self.presentmentPrices = prices;
                return lenses;
              })
              .catch(function () {
                return lenses;
              });
          }

          return lenses;
        });
    };

    return true;
  }

  if (patch()) {
    return;
  }

  var elapsed = 0;
  var timer = window.setInterval(function () {
    elapsed += POLL_MS;
    if (patch() || elapsed >= MAX_WAIT_MS) {
      window.clearInterval(timer);
    }
  }, POLL_MS);
})();
